import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Button,
  TextField,
  Card,
  MenuItem,
  Typography
} from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import Link from '@material-ui/core/Link';
import { Link } from "react-router-dom";

import {
  login,
  getMetaAssets,
} from "../../store/actions/auth.actions";
import { updateBaseUrl } from "../../store/actions/config.actions";
import useStyles from "./styles";
import { api, auth } from "../../common/api-utils";
import { pathOr } from "ramda";
import SkeletonShell from '../../components/Skeleton/index';
import ForgotPassword from '../../components/ForgotPassword';
import ParticlesBg from 'particles-bg';
import { toast } from "react-toastify";

const getFaviconEl = () => document.getElementById("favicon");

const Login = ({ history }) => {
  let { uname, AssetRequest, AppType, AuthId, AccessToken } = useParams();

  // Decode a URL parameter Start
  const uname2 = uname?window.atob(uname):uname ;
  const AssetRequest2 = AssetRequest?window.atob(AssetRequest):AssetRequest;
  const AppType2 = AppType?window.atob(AppType):AppType;
  const AuthId2 = AuthId?window.atob(AuthId):AuthId;
  const AccessToken2 = AccessToken?window.atob(AccessToken):AccessToken;
  // Decode a URL parameter End

  // console.log("history=================3333",uname,AssetRequest,history)
  const [username, setUsername] = useState(uname2 || '');
  // const [password, setPassword] = useState(AuthId2?process.env.REACT_APP_CRM_PWD:'');
  const [password, setPassword] = useState(AuthId2?btoa(uname2).slice(btoa(uname2).length-10,btoa(uname2).length):'');
  const [logo, setLogo] = useState('');
  const [logoLoading, setLogoLoading] = useState(false);
  const [isForgot, setIsForgot] =useState(false);
  const [url, setUrl] = useState(process.env.REACT_APP_BASE_URL);
  const [checkUrl,setCheckUrl] =useState(false);
  const classes = useStyles();

  const dispatch = useDispatch();
  const { loading, isAuthenticated ,loginLoading} = useSelector(
    (state) => state.auth,
  );
  
  localStorage.setItem("uname", uname2?uname2:'');
  localStorage.setItem("AssetRequest", AssetRequest2?AssetRequest2:'');
  localStorage.setItem("AppType", AppType2?AppType2:'');
  localStorage.setItem("AuthId", AuthId2?AuthId2:'');
  localStorage.setItem("axa_access_token", AccessToken2?AccessToken2:'');

  useEffect(() => {
    if(AuthId===undefined && !localStorage.getItem("logo")){
       getLogos()
      };
  }, []);
  const getLogos = async () => {
    try {
      setLogoLoading(true);

      // const res = await getMetaAssets();
     
      const validateLoginParams={'params':{'authId':AuthId?AuthId:'','accessToken':AccessToken?AccessToken:''},'basicAuthorization': process.env.REACT_APP_VERIFY_Basic_Authorization, 'verify_URL':process.env.REACT_APP_VERIFY_URL};
      dispatch(getMetaAssets(validateLoginParams)).then(function(res){
        if(typeof res === 'object'){
         
          const faviconEl = getFaviconEl();
          if (pathOr(undefined, ["data", "logo_icon"], res)) {
            // if(res.data['rr'] && res.data['rr'].status === 400){
              
            // }
            if(pathOr(false, ['data','rr','isValidToken'], res)){
              localStorage.setItem("favicon", res.data.logo_icon);
              if(AuthId){
                const payload = {
                  username,
                  password,
                  grant_type: process.env.REACT_APP_GRANT_TYPE,
                  client_id: process.env.REACT_APP_CLIENT_ID,
                  client_secret: process.env.REACT_APP_CLIENT_SECRET,
                };
                dispatch(login(payload)).then(function(){
                  setLogoLoading(false);
                });
              }else{
                setLogoLoading(false);
              }
            }else{
              history.push("/login");
              // toast('AXA access token has bean expired!');
              setLogoLoading(false);
              faviconEl.href = pathOr("", ["data", "logo_icon"], res);
              setLogo(pathOr("No Logo", ["data", "logo_image"], res));
              return;
            }
            
          }

          faviconEl.href = pathOr("", ["data", "logo_icon"], res);
          setLogo(pathOr("No Logo", ["data", "logo_image"], res));
        }else{
          setLogo('/company_logo.png');
          setLogoLoading(false);  
        }
    })
    } catch (ex) {
      console.log(ex);
      
    }
  };

  if (isAuthenticated) {
    history.push("/app/Home");
    return;
  }
  const validURL = (str) =>{
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
  const onSubmit = async () => {
    const payload = {
      username,
      password,
      grant_type: process.env.REACT_APP_GRANT_TYPE,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    };
    dispatch(login(payload));
  };

  const setBaseUrl = (e) => {
    let mainUrl = e.target.value;
    if(validURL(mainUrl))
    {
    dispatch(updateBaseUrl(mainUrl+'/Api'));
    auth.setBaseURL(mainUrl+'/Api');
    api.setBaseURL(mainUrl+'/Api');    
    }
    setUrl(mainUrl);
  };

  return (
    <div className={classes.container}>
      <ParticlesBg type="cobweb" color="#b2dae8" bg={true}  rps='0.9' />
      <Card className={classes.card}>
        {/* {console.log("AuthIdAuthIdAuthId",AuthId)} */}
         {/* <Typography
                variant="h6"
                weight="medium"
                color="error"
                className={classes.licenseMessage}
              >
              Your license has expired.
              </Typography> */}

        {AuthId===undefined && !localStorage.getItem("logo")?
        <div className={classes.formWrapper}>
          {!logoLoading ? (
            <img
              src={logo}
              alt="logo"
              style={{ margin: "5px 0", maxHeight:'100px' }}
            />
          ) : (
              <Typography
                variant="h6"
                weight="medium"
                className={classes.logotype}
              >
              

              </Typography>
            )}
          {!isForgot ? 
          <> 
            <form onSubmit={onSubmit}>
            {!logoLoading || !AuthId ? 
            <>
              <TextField
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                margin="normal"
                placeholder="Username"
                type="username"
                className={classes.formField}
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
              />
              <TextField
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
                placeholder="Password"
                type="password"
                className={classes.formField}
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
              />
             
              {loading ? (
                <div className={classes.spinnerContainer}>
                  <CircularProgress size={26} />
                </div>
              ) : (
                <>
                <Button
                  type="submit"
                  onClick={onSubmit}
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={!username.length || !password.length}
                  className={classes.formField}
                >
                  Login
                </Button>
              <div className={classes.linkBox}>
                    <Link to={`#`} className={classes.fixedCenter} onClick={() => setIsForgot(true)} variant="body2">
                     Forgot Password?
                  </Link>
                  </div>
               
                </>
                )}
                </>:
                // Added By deep On 09-02-2020 for login page skeleton
                <SkeletonShell layout="login"/>
            }
            </form>
           
          </>
          : <ForgotPassword urldata={url} setIsForgot={setIsForgot}/>}
          
        </div>:<SkeletonShell layout="login"/>}
      </Card>
    </div>
  );
};

export default Login;
